import './Field.css';

export default function Input({ error = false, className = '', ...rest }) {
  return (
    <input
      className={`field-control ${error ? 'field-control-error' : ''} ${className}`}
      aria-invalid={error || undefined}
      {...rest}
    />
  );
}